// Single source of truth for cross-line (越線) tripwire stroke colours,
// shared by the floor-plan editor overlay (TripwireOverlay) and the live
// dashboard (LiveCanvas, both live + replay -- it reuses the same render
// path) so every surface draws the same line in the same colour. Per the
// 2026-09-22(b) UX revision: ONE colour for every active line, a second
// (grey) colour for inactive lines, both SOLID -- no dashed styling. A
// disabled tripwire should read as "exists, but switched off", not as
// "half-drawn" or "still being edited".
//
// ACTIVE: a magenta-pink. Chosen to read clearly against the orange already
// used for protection-zone radii / equipment alert zones on the same canvas
// (StationList/StaticStation, EquipmentLayer) -- an active tripwire must
// never be mistaken for a protection zone at a glance.
// INACTIVE: a neutral mid-grey, matching the muted "switched off" language
// used elsewhere in this feature (e.g. StationPopover's secondary text),
// rather than a diluted tint of the active colour.
export const TRIPWIRE_ACTIVE_COLOR = "#eb2f96";
export const TRIPWIRE_INACTIVE_COLOR = "#8c8c8c";

export const getTripwireColor = (enabled) =>
  enabled ? TRIPWIRE_ACTIVE_COLOR : TRIPWIRE_INACTIVE_COLOR;
